import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getRole = async (userName) => {
    const res = await axios.post(`${API_URL}auth/get_role_user`, {
        username: userName,
    });
    return res;
};
export const get_all_role = async () => {
    const res = await axios.post(`${API_URL}auth/get_all_role`);
    return res;
};

export const create_User = async (values) => {
    const res = await axios.post(`${API_URL}auth/create_user`, {
        ...values,
    });
    return res;
};

export const delete_User = async (username) => {
    const res = await axios.post(`${API_URL}auth/delete_user`, {
        username: username,
    });
    return res;
};

export const change_lock_user = async (username, status) => {
    const res = await axios.post(`${API_URL}auth/change_lock_user`, {
        username: username,
        status: status,
    });
    return res;
};
export const edit_User = async (values) => {
    const res = await axios.post(`${API_URL}auth/update_user`, {
        ...values,
    });
    return res;
};

export const Cretae_role = async (values) => {
    const res = await axios.post(`${API_URL}auth/create_role`, {
        ...values,
    });
    return res;
};

export const delete_Roles = async (roleIds) => {
    const res = await axios.post(`${API_URL}auth/delete_roles`, {
        roleIds: roleIds,
    });
    return res;
};

export const edit_Roles = async (values) => {
    const res = await axios.post(`${API_URL}auth/update_role`, {
        ...values,
    });
    return res;
};
